<template>
    <div id="blog-page">
        <div v-if="error" class="container mtb-80">
            <app-back :title="error"></app-back>
        </div>

        <section class="hero is-info is-medium is-bold">
            <div v-if="postsCategory" class="hero-body" :style="{ 'background-image': 'url(' + postsCategory.imagePath + ')' }">
                <div class="container has-text-centered">
                    <h1 class="title">{{ postsCategory.name }}</h1>
                    <div class="description" v-html="postsCategory.description"></div>
                </div>
            </div>
        </section>

        <div class="container is-fluid bottom-header">
            <div v-if="postsCategory" class="breadcrumbs-parent">
                <ul>
                    <li><router-link to="/blog">Blog</router-link></li>
                    <li v-text="capitalize(postsCategory.name)"></li>
                </ul>
            </div>
            <app-mail-categories-sticky :items="postsCategories"></app-mail-categories-sticky>
        </div>

        <div class="container is-fluid">
            <section class="articles columns is-multiline">

                <div class="column is-full-mobile is-half-tablet is-one-third-desktop shadowing" v-for="post in posts" :key="post.title">
                    <div class="card-content">
                        <div class="media">
                            <div class="media-content has-text-centered">
                                <p class="title article-title">
                                    <router-link  :to="'/blog/' + post.category.slug + '/' + post.slug">
                                        {{ post.title | capitalize }}
                                    </router-link>
                                </p>

                                <div class="tags has-addons level-item">
                                    <span class="tag is-rounded is-dark">@{{post.user.first_name }} {{ post.user.last_name }} </span>
                                    <span class="tag is-rounded">
                                        {{ post.created }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="content article-body" v-html="post.content">
                        </div>
                    </div>
                    <div class="card-foot">
                       <hr />
                       <app-centered-button :link="'/blog/' + post.category.slug + '/' + post.slug" text="Beri naprej"></app-centered-button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { ApiHome } from '../../.env';
import { mapGetters } from 'vuex';
import StringsMixin from '../../mixins/StringsMixin';
import HeaderBar from '../../components/layout/HeaderBar.vue';
import BackButton from '../../components/layout/BackButton.vue';
import MoreButton from '../../components/layout/MoreButton.vue';
import Silentbox from '../../components/elements/silentbox/Silentbox.vue';
import MailCategoriesSticky from '../../components/layout/MailCategoriesSticky.vue';

export default {
    props: ['category'],
    mixins: [StringsMixin],

    data() {
        return {
            endpoint: ApiHome+ 'posts',
            endpointSearch: ApiHome + 'searchPosts',
            query: '',
            errorClass: '',
        }
    },

    components: {
        'app-header': HeaderBar,
        'app-sb': Silentbox,
        'app-back': BackButton,
        'app-centered-button': MoreButton,
        'app-mail-categories-sticky': MailCategoriesSticky,
    },

    computed: {
        ...mapGetters([
            'postsCategory',
            'posts',
            'postsCategories',
            'loading',
            'error',
            'title',
        ]),
    },

    methods: {
        fetchPosts(category) {
            if(typeof category === "undefined") {
                category = this.category;
            }
            this.$store.dispatch('fetchPosts', this.endpoint + '/' + category);
        },

        postDate(post) {
            if(post.updated === '') {
                return post.created;
            }
            return post.updated;
        },

        // Triggered from button click to load new items
        getPosts(item) {
            // console.log('clicked - get new categories ', this.category, item);
            this.fetchPosts(item);
        }

    },

    created() {
        this.fetchPosts();
        // console.log('BlogCategories - Component mounted.')
    }
}
</script>


<style lang="scss">

@import "../../style/app.scss";
@import "../../style/blog.scss";

</style>


// WEBPACK FOOTER //
// src/views/blog/BlogCategories.vue